import { render, staticRenderFns } from "./DetailMerchant.vue?vue&type=template&id=20812afe"
import script from "./DetailMerchant.vue?vue&type=script&lang=js"
export * from "./DetailMerchant.vue?vue&type=script&lang=js"
import style0 from "./DetailMerchant.vue?vue&type=style&index=0&id=20812afe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports